import {storyBase} from "@/lib/api/sanity/queries/storyBase";

const storiesByIds = `
* [_id in $ids]
${storyBase}
`
export default storiesByIds
